import styled from "styled-components";

import { DEFAULT_MARGIN_L, DEFAULT_MARGIN_M } from "@src/common/styles/const";

//TODO: Add mobile view and replace button wrappers in modals
export const ModalButtonsWrapper = styled.div`
  display: flex;
  margin-top: ${DEFAULT_MARGIN_L}px;
  align-self: flex-end;
  gap: ${DEFAULT_MARGIN_M}px;
`;
